import CommonRouterSection from '@/components/layout/CommonRouterSection'

export default {
  path: '/design',
  name: 'design',
  component: CommonRouterSection,
  children: [  
    {
      path: 'viewslist',
      name: 'viewslist',
      component: () => import('@/views/Design.vue')
    },
    {
      path: 'simple',
      name: 'simple',
      component: () => import('@/views/design/simplesearch/Simplesch.vue')
    },
    {
      path: 'advsearch',
      name: 'advsearch',
      component: () => import('@/views/design/simplesearch/Simplesch2.vue')
    },
    {
      path: 'advsearchoversea',
      name: 'advsearchoversea',
      component: () => import('@/views/design/simplesearch/Simplesch3.vue')
    },
    {
      path: 'advsearchresult',
      name: 'advsearchresult',
      component: () => import('@/views/design/simplesearch/Simpleschresult.vue')
    },
    // {
    //   path: 'schwizard',
    //   name: 'schwizard',
    //   component: () => import('@/views/design/simplesearch/Searchwizard.vue')
    // },
    // {
    //   path: 'keywordsch',
    //   name: 'keywordsch',
    //   component: () => import('@/views/design/simplesearch/Keywordsearch.vue')
    // },
    // {
    //   path: 'bookmark',
    //   name: 'bookmark',
    //   component: () => import('@/views/design/bookmark/Bookmark.vue')
    // },
    {
      path: 'mymemo',
      name: 'mymemo',
      component: () => import('@/views/design/mymemo/Mymemo.vue')
    },
    {
      path: 'schhistory',
      name: 'schhistory',
      component: () => import('@/views/design/myquery/Searchhistory.vue')
    },
    {
      path: 'myquerylist',
      name: 'myquerylist',
      component: () => import('@/views/design/myquery/Myquerylist.vue')
    },
    {
      path: 'faqs',
      name: 'faqs',
      component: () => import('@/views/design/userguide/Faqs.vue')
    },
    {
      path: 'adbsearch',
      name: 'adbsearch',
      component: () => import('@/views/design/adbsearch/Adbsearch.vue')
    },
    {
      path: 'adbsearch2',
      name: 'adbsearch2',
      component: () => import('@/views/design/adbsearch/Adbsearch2.vue')
    },
    {
      path: 'adbsearch3',
      name: 'adbsearch3',
      component: () => import('@/views/design/adbsearch/Adbsearch3.vue')
    },
    {
      path: 'adbsearchfull',
      name: 'adbsearchfull',
      component: () => import('@/views/design/adbsearch/Adbsearchfull.vue')
    },
    {
      path: 'ppt12',
      name: 'ppt12',
      component: () => import('@/views/design/PPT12.vue')
    },
  ]
}
